import React, { useState } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import Button from '../../../../common/components/Button'
import Row from '../../../../common/components/Row'
import Text, { Paragraph } from '../../../../common/components/Text'
import Card, { CardHeader } from '../../../../common/components/Card'
import UsageBar from './UsageBar'
import PaymentModal from './PaymentModal'
import Hr from '../../../../common/components/Hr'
import Form, { FormHeader } from '../../../../common/components/Form'
import Label, { LabelSpacer } from '../../../../common/components/Label/Label'
import CancelSubModal from './CancelSubModal'
import Content from '../../../../common/components/Content'
import TestPlanSwitcher from './TestPlanSwitcher'
import Icon from 'common/components/Icon'
import styled from 'react-emotion'
import { space4, space16 } from '../../../../common/style'

const Header = styled(props => <Text bold {...props} />)({
  textAlign: 'center',
  display: 'block',
  fontSize: 28,
  lineHeight: 1,
  marginTop: space16,
  marginBottom: space4
})

const SubHeader = styled(props => <Text grey {...props} />)({
  textAlign: 'center',
  display: 'block',
  fontSize: 16,
  lineHeight: 1,
  marginTop: space4,
  marginBottom: space16
})

const Plans = ({ user, subscription, plans, smallScreen }) => {
  const { t } = useTranslation()
  const currentPlan = subscription ? subscription.planId : 'basic'
  const blockLimit = plans && (user.blockLimit || plans[currentPlan].blockLimit)
  const [requestedPlan, setRequestedPlan] = useState()
  const [cancelSub, setCancelSub] = useState()
  return (
    <>
      {smallScreen && (
        <Row z>
          <Button to="/settings">
            <Icon icon="menu" />
          </Button>
          <Label>{t('settings.plan')}</Label>
        </Row>
      )}
      <Content scroll>
        <Form>
          <Header>{t('settings.plan')}</Header>
          <SubHeader>
            <Trans
              i18nKey={`plans.${currentPlan}.paymentDetails`}
              values={subscription}
            >
              Next payment of <Text bold>$x</Text> on <Text bold>date</Text>
            </Trans>
          </SubHeader>

          <Hr />

          <FormHeader>{t('settings.plans.current')}</FormHeader>

          {plans && (
            <Card>
              <CardHeader>
                <Text bold>{t(`plans.${currentPlan}.name`)}</Text>
                <Text grey>
                  {t(`plans.${currentPlan}.price`, plans[currentPlan])}
                </Text>
              </CardHeader>

              <Paragraph grey small>
                {t(`plans.${currentPlan}.details`)}
              </Paragraph>

              <Hr />

              <Row noPad>
                {currentPlan !== 'basic' && (
                  <>
                    <Button autoWidth medium onClick={() => setCancelSub(true)}>
                      {t('settings.plans.cancel')}
                    </Button>
                    {/* Extra spacing that's here but in no other Row */}
                    <span />
                  </>
                )}
                <UsageBar
                  medium
                  flex
                  grey={user.blockCount < blockLimit}
                  danger={user.blockCount >= blockLimit}
                  usage={user.blockCount / blockLimit}
                >
                  <Text grey={user.blockCount < blockLimit} normal>
                    {t('settings.plans.usageLabel')}
                  </Text>
                  <LabelSpacer />
                  <Text normal>
                    {t('settings.plans.usage', {
                      blockCount: user.blockCount,
                      blockLimit
                    })}
                  </Text>
                </UsageBar>
              </Row>
            </Card>
          )}
          <Hr />
          <FormHeader>{t('settings.plans.available')}</FormHeader>
          {plans &&
            Object.values(plans)
              .filter(plan => plan.current && plan.id !== currentPlan)
              .sort((a, b) => a.blockLimit - b.blockLimit)
              .map(plan => {
                return (
                  <Card key={plan.id}>
                    <CardHeader>
                      <Text bold>{t(`plans.${plan.id}.name`)}</Text>
                      <Text grey>{t(`plans.${plan.id}.price`, plan)}</Text>
                    </CardHeader>

                    <Paragraph grey small>
                      {t(`plans.${plan.id}.details`)}
                    </Paragraph>

                    <Hr />

                    {subscription ? (
                      <Label medium grey flex>
                        <Text grey normal>
                          {t('settings.plans.cancelToSwitch')}
                        </Text>
                      </Label>
                    ) : (
                      <Button medium onClick={() => setRequestedPlan(plan.id)}>
                        {t('settings.plans.upgrade')}
                      </Button>
                    )}
                  </Card>
                )
              })}

          {cancelSub && (
            <CancelSubModal
              close={() => setCancelSub(null)}
              user={user}
              subscription={subscription}
            />
          )}

          {requestedPlan && (
            <PaymentModal
              close={() => setRequestedPlan(null)}
              plan={plans[requestedPlan]}
              user={user}
            />
          )}
          <TestPlanSwitcher userId={user.id} />
        </Form>
      </Content>
    </>
  )
}

export default Plans
